import { useState, useEffect } from "react";
import * as Const from "./../_Const";

export default function useDarkMode() {
  const DARK = "dark";
  const LIGHT = "light";
  let lsTheme = localStorage.getItem(Const.LS_THEME);
  if (!lsTheme) {
    lsTheme = LIGHT;
  }

  const [theme, setTheme] = useState(lsTheme);
  let colorTheme = theme === DARK ? LIGHT : DARK;
  const isDarkMode = theme === DARK;

  //console.log(isDarkMode);
  //localStorage.setItem("theme", theme);

  function toggleTheme() {
    //console.log("toggle", theme);

    if (theme === DARK) {
      setTheme(LIGHT);
    } else {
      setTheme(DARK);
    }
  }

  function setThemeByValue(isDark) {
    //console.log("setThemeByValue isDark:" + isDark);
    // console.log("theme:" + theme);
    // console.log("colorTheme:" + colorTheme);

    //proved zmenu theme jen kdyz je rozdilny server od local
    if (isDark && theme === LIGHT) {
      setTheme(DARK);
    } else if (!isDark && theme === DARK) {
      setTheme(LIGHT);
    }
  }

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(colorTheme);
    root.classList.add(theme);
    //console.log("changinng theme:" + theme, colorTheme);

    localStorage.setItem(Const.LS_THEME, theme);
  }, [theme, colorTheme]);

  return [isDarkMode, toggleTheme, setThemeByValue];
}
